import { render } from "./linkbutton.vue?vue&type=template&id=73befaec"
import script from "./linkbutton.vue?vue&type=script&lang=js"
export * from "./linkbutton.vue?vue&type=script&lang=js"

import "./linkbutton.vue?vue&type=style&index=0&id=73befaec&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__